import { LegalTypes } from './types'
import { LegalType } from '../../types/legal'

export function saveLegal(legal: LegalType) {
  return {
    type: LegalTypes.SAVE_LEGAL,
    payload: legal
  }
}
